<!--
 * @Description: 市场准入 11 - 15 废
 * @Date: 2022-05-24 10:57:37
-->
<template>
  <div class="academy-edit-box">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="210px"
      class="ruleForm"
      label-suffix="："
    >
      <submit-result
        :auditList="addEditMixin_auditList"
        :projectStatus="ruleForm.projectStatus"
      ></submit-result>
      <div class="xrk-project-form">
        <div>
          <xrk-subtitle>项目信息</xrk-subtitle>
          <el-form-item label="项目编码" prop="projectName">
            <el-input v-model.trim="ruleForm.projectNo" disabled></el-input>
            <el-button
              type="primary"
              class="copyBtn_1"
              :data-clipboard-text="ruleForm.projectNo"
              @click="$copy('copyBtn_1')"
            >
              复制
            </el-button>
          </el-form-item>
          <el-form-item label="客户企业" prop="enterpriseId" v-if="hasIndustry">
            <el-input
              disabled
              :value="ruleForm.industryEnterpriseName"
            ></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="projectName">
            <el-input disabled v-model.trim="ruleForm.projectName"></el-input>
          </el-form-item>
          <el-form-item
            label="项目简介"
            prop="introduction"
            class="absoluteBox"
          >
            <el-input
              type="textarea"
              v-model.trim="ruleForm.introduction"
              placeholder="请输入项目简介"
              :rows="7"
              maxlength="200"
              :show-word-limit="true"
              :disabled="addEditMixin_introductionDisbaled"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="`${addEditMixin_projectTypeName}价格：(不含税)`"
            v-if="hasIndustry"
            prop="price"
          >
            <span slot="label" class="long-label">
              {{ `${addEditMixin_projectTypeName}价格：(不含税)` }}
            </span>
            <el-input
              :disabled="addEditMixin_disbaled"
              v-model="ruleForm.price"
            ></el-input>
            <span>元</span>
          </el-form-item>
          <el-form-item prop="csoPrice">
            <span slot="label" class="long-label">
              {{ `${addEditMixin_projectTypeName}价格` }}
              <br />
              (终端结算单价)&nbsp;
            </span>
            <el-input
              :disabled="addEditMixin_disbaled"
              v-model.trim="ruleForm.csoPrice"
              :maxlength="11"
            ></el-input>
            <span>元</span>
          </el-form-item>
          <el-form-item label="税率" v-if="hasIndustry" prop="contractScale">
            <el-input
              :disabled="addEditMixin_disbaled"
              v-model.trim="ruleForm.contractScale"
            ></el-input>
            <span>%</span>
            <!-- {{ ruleForm.contractScale | transScale }} -->
          </el-form-item>
          <el-form-item label="背景需求" prop="projectBackground">
            <el-select
              v-model="ruleForm.projectBackground"
              :disabled="addEditMixin_disbaled"
              placeholder="请选择背景"
              @change="addEditMixin_validateBackground"
            >
              <el-option
                v-for="item in addEditMixin_backgroundList"
                :key="item.id"
                :value="item.id"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="总任务量" prop="taskSumCount">
            <el-input disabled :value="ruleForm.taskSumCount || 0"></el-input>
          </el-form-item>
          <el-form-item label="已完成任务量">
            <el-input disabled :value="ruleForm.finishSumCount || 0"></el-input>
          </el-form-item>
          <el-form-item label="审核人员对其可见">
            <reviewer
              :disabled="addEditMixin_disbaled"
              :info="ruleForm"
            ></reviewer>
          </el-form-item>
          <el-form-item label="姓名脱敏规则" prop="projectDesensitizationRule">
            <el-radio-group
              v-model="ruleForm.projectDesensitizationRule"
              :disabled="
                addEditMixin_disbaled ||
                  +ruleForm.desensitizationRuleDisable === 1
              "
            >
              <el-radio :label="2">
                部分隐藏
                <span style="color:rgb(177, 177, 177)">例：王*二</span>
              </el-radio>
              <el-radio :label="1">
                字母缩写
                <span style="color:rgb(177, 177, 177)">例：WZS</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div>
          <xrk-subtitle>需求信息</xrk-subtitle>
          <!--todo 添加需求信息-->
          <el-form-item label="封面图" prop="bgUrl">
            <GenerateImage
              :initUrl="ruleForm.bgUrl"
              :oldUrl="ruleForm.oldBgUrl"
              :initType="ruleForm.bgUrlSource"
              @done="addEditMixin_finishUpload"
              @finish="addEditMixin_finishUpload"
              @changeType="addEditMixin_changeBgType"
              :auditStatus="ruleForm.auditStatus"
              :disabled="addEditMixin_disbaled"
            ></GenerateImage>
          </el-form-item>
          <el-form-item label="产品名称" prop="commonName">
            <el-input
              :disabled="addEditMixin_disbaled"
              v-model.trim="ruleForm.commonName"
              placeholder="请输入产品名称"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="生产厂商" prop="enterprise">
            <el-input
              :disabled="addEditMixin_disbaled"
              v-model.trim="ruleForm.enterprise"
              placeholder="请输入生产厂商"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="产品规格" prop="guige">
            <el-input
              :disabled="addEditMixin_disbaled"
              v-model.trim="ruleForm.guige"
              placeholder="请输入产品规格"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="职业认证" prop="isOccupationAuth">
            <el-radio-group
              v-model="ruleForm.isOccupationAuth"
              :disabled="addEditMixin_disbaled"
            >
              <el-radio
                border
                class="auth-type"
                :label="item.type"
                v-for="(item, index) in isOccupationAuthArray"
                :key="`way${index}`"
              >
                {{ item.value }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="认证类型"
            prop="occupationType"
            v-if="ruleForm.isOccupationAuth"
          >
            <!-- <span>认证类型：</span> -->
            <span>
              <el-select
                v-model="ruleForm.occupationType"
                :disabled="addEditMixin_disbaled"
                placeholder="请选择认证类型"
              >
                <el-option
                  v-for="item in occupationTypeArray"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </span>
          </el-form-item>
          <el-form-item
            label="认证方式"
            prop="occupationAuthMode"
            v-if="ruleForm.isOccupationAuth"
          >
            <el-radio-group
              v-model="ruleForm.occupationAuthMode"
              :disabled="addEditMixin_disbaled"
            >
              <el-radio
                border
                :label="item.type"
                v-for="(item, index) in occupationAuthModeArray"
                :key="`way${index}`"
              >
                {{ item.value }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="C端图片查重："
            v-if="addEditMixin_repeatFormItemEnabled"
            prop="isCPicRepeat"
          >
            <el-radio-group
              v-model="ruleForm.isCPicRepeat"
              :disabled="addEditMixin_disbaled"
            >
              <el-radio border class="auth-type" :label="1">
                是
              </el-radio>
              <el-radio border class="auth-type" :label="0">
                否
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <common-items :disabled="addEditMixin_disbaled" />-->
          <el-form-item
            v-for="(ele, i) in addEditMixin_formItems"
            :label="ele.label"
            :key="i"
            :prop="ele.prop"
          >
            <el-input
              v-model="ruleForm[ele.prop]"
              :disabled="addEditMixin_disbaled"
              v-bind="ele"
            >
              <template #append>
                {{ ele.suffix }}
                <el-tooltip placement="top" effect="light">
                  <div slot="content" v-html="ele.content"></div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            </el-input>
          </el-form-item>
        </div>
      </div>
      <div class="xrk-project-footer">
        <template v-if="addEditMixin_showSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_submitForm('ruleForm')"
            :loading="btLoading"
            :disabled="addEditMixin_disbaled"
          >
            保存
          </el-button>
          <submit-verify-btn
            @finish="addEditMixin_finishSubmit"
            :auditStatus="ruleForm.auditStatus"
            :ifDis="addEditMixin_disbaled"
          ></submit-verify-btn>
        </template>
        <el-button
          type="primary"
          plain
          v-if="addEditMixin_showAginEditBtn"
          @click="addEditMixin_onAginEditProject(ruleForm)"
          :loading="btLoading"
          :disabled="addEditMixin_aginEditBtnDisabled"
        >
          再次编辑
        </el-button>
        <template v-if="addEditMixin_showAginSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_cancelEditProject('ruleForm')"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            plain
            @click="addEditMixin_confirmEditProject('ruleForm')"
            :loading="btLoading"
          >
            提交审核
          </el-button>
        </template>
        <submit-verify-and-next-btn
          :info="ruleForm"
          :submitFn="addEditMixin_finishSubmit"
        ></submit-verify-and-next-btn>
      </div>
    </el-form>
  </div>
</template>
<script>
import { company } from '@/api/ajax';

import addEdit from '@/page/project-classify/src/mixins/add-edit';

export default {
  name: 'accessSuper',
  mixins: [addEdit],
  data() {
    return {
      searchAjax: company.list,

      prop: {
        label: 'enterpriseName',
        code: 'id'
      },
      defaultObj: {
        enterpriseName: '',
        id: ''
      },
      ruleForm: {
        commonName: '',
        transmitList: [''],
        feedbackList: [''],
        approvalNumber: '',
        guige: '',
        jixing: '',
        enterprise: ''
      },
      // 校验
      rules: {}
    };
  },

  async created() {
    const data = await this.addEditMixin_init();
    let { tCrmProduct, messageList, customerFeedbackList } = data;

    tCrmProduct.productId = tCrmProduct.id;
    delete tCrmProduct.id;

    messageList = messageList.length ? messageList : [''];
    customerFeedbackList = customerFeedbackList.length
      ? customerFeedbackList
      : [''];
    const obj = {
      transmitList: messageList,
      feedbackList: customerFeedbackList,
      ...tCrmProduct
    };

    this.defaultObj = {
      enterpriseName: this.ruleForm.industryEnterpriseName,
      id: this.ruleForm.industryEnterpriseId
    };
    this.ruleForm = { ...this.ruleForm, ...obj }; //解决el-select的label不显示bug，需要深拷贝一下ruleForm

    this.$emit('resetRuleForm', this.ruleForm);
  }
};
</script>
<style lang="scss">
.academy-edit-box {
  .ruleForm .el-form-item .el-input,
  .ruleForm .el-form-item .el-textarea {
    width: 350px;
  }
}
</style>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  margin: 1em 0 1em 20px;
  border-left: 5px solid #2878ff;
  text-indent: 1em;
  font-weight: bold;
}

.long-label {
  font-size: smaller;
}

// .auth-type{
//   padding: 10px;
//   border: 1px solid #dcdfe6;
//   border-radius: 5px;
//   &.is-checked{
//     border-color: #1890ff;
//   }
// }
</style>
